import * as React from "react";
import Booth from "../../_data/models/Booth";
import {ShopsRoutes} from "../../routes";
import {Link} from "react-router-dom";


interface Props {
    booth: Booth;
    viewBooth: (booth: Booth) => void;
}

export const BoothListItemComponent = (props: Props) => {
    const {booth, viewBooth} = props;

    return (
        <li>
            <div className="media-object">
                <div className="media-object-section flushed middle">
                    <div className="img-wrapper small-img-fit">
                        <img src={booth.imageable().primaryPictureUrl} />
                    </div>
                </div>
                <div className="media-object-section middle">
                    <div className="text-group">
                        <p><b>{booth.toString()}</b></p>
                        <small className="subheader">{booth.shop.toString()}&nbsp;</small>
                        <small className="subheader">{booth.shop.address()}</small>
                    </div>
                </div>
            </div>
            <Link to={ShopsRoutes.viewBooth(booth.shopId, booth.id)} className="button primary pull-right">
                <i className="fa fa-eye-o"></i>&nbsp; View Booth
            </Link>
        </li>
    );
};

export default BoothListItemComponent;


// WEBPACK FOOTER //
// ./app/client/booth/components/BoothListItemComponent.tsx